define(["exports", "react", "@reach/accordion", "react-intl-universal", "styled-components", "moment", "../../atoms", "../../atoms/Carret"], function (_exports, _react, _accordion, _reactIntlUniversal, _styledComponents, _moment, _atoms, _Carret) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.AccordionPanelCustom = _exports.AccordionButtonCustom = void 0;
  _exports.PcdBody = PcdBody;
  _exports.ReportWrapper = void 0;
  _react = _interopRequireWildcard(_react);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _moment = _interopRequireDefault(_moment);
  var AccordionButtonCustom = (0, _styledComponents.default)(_accordion.AccordionButton).withConfig({
    displayName: "PcdBody__AccordionButtonCustom",
    componentId: "sc-pxi808-0"
  })(["background-color:", ";border:1px solid ", ";cursor:pointer;margin:0;padding:16px;text-align:left;width:100%;h3,p{margin:0;padding:0;}div{align-items:center;display:flex;justify-content:space-between;}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.white;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.lightGray;
  });
  _exports.AccordionButtonCustom = AccordionButtonCustom;
  var AccordionPanelCustom = (0, _styledComponents.default)(_accordion.AccordionPanel).withConfig({
    displayName: "PcdBody__AccordionPanelCustom",
    componentId: "sc-pxi808-1"
  })(["background-color:", ";border:solid 1px ", ";padding:16px;text-align:left;"], function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.white;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.lightGray;
  });
  _exports.AccordionPanelCustom = AccordionPanelCustom;

  var ReportWrapper = _styledComponents.default.div.withConfig({
    displayName: "PcdBody__ReportWrapper",
    componentId: "sc-pxi808-2"
  })(["align-items:center;display:flex;"]);

  _exports.ReportWrapper = ReportWrapper;

  var Anchor = _styledComponents.default.a.withConfig({
    displayName: "PcdBody__Anchor",
    componentId: "sc-pxi808-3"
  })(["align-items:center;border:1px solid ", ";border-radius:4px;color:", ";cursor:pointer;display:flex;font-size:14px;font-weight:", ";justify-content:space-between;line-height:24px;margin-right:4px;padding:6px 16px;text-decoration:none;width:fit-content;[data-icon='svg-icon']{margin-right:6px;width:16px;}"], function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.lightGray;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.darkestGrey;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.font.semibold;
  });

  var H3Styled = (0, _styledComponents.default)(_atoms.H3).withConfig({
    displayName: "PcdBody__H3Styled",
    componentId: "sc-pxi808-4"
  })(["margin:0;"]);
  var PStyled = (0, _styledComponents.default)(_atoms.P).withConfig({
    displayName: "PcdBody__PStyled",
    componentId: "sc-pxi808-5"
  })(["margin:0;margin-bottom:16px;"]);

  function PcdBody(_ref8) {
    var type = _ref8.type,
        iconType = _ref8.iconType,
        currentLanguage = _ref8.currentLanguage;

    var _useState = (0, _react.useState)(-1),
        accordionIndex = _useState[0],
        setAccordionIndex = _useState[1];

    var _useState2 = (0, _react.useState)([]),
        data = _useState2[0],
        setData = _useState2[1];

    (0, _react.useEffect)(function () {
      var arrayData = type.filter(function (item) {
        return item.titulo !== 'Observações';
      });
      if (arrayData.length) setData(arrayData);
    }, [type]);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data != null && data.length ? /*#__PURE__*/_react.default.createElement(_accordion.Accordion, {
      index: accordionIndex,
      onChange: function onChange(value) {
        return setAccordionIndex(value);
      }
    }, data != null && data.length ? data == null ? void 0 : data.map(function (item, index) {
      var _item$laudo, _item$laudo2, _item$laudo3, _item$laudo4;

      return /*#__PURE__*/_react.default.createElement(_accordion.AccordionItem, {
        key: index
      }, /*#__PURE__*/_react.default.createElement(AccordionButtonCustom, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, iconType(item.slug), /*#__PURE__*/_react.default.createElement(H3Styled, null, item.titulo)), /*#__PURE__*/_react.default.createElement(_Carret.DropdownCaret, {
        isOpen: accordionIndex === index
      }))), /*#__PURE__*/_react.default.createElement(AccordionPanelCustom, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(H3Styled, null, _reactIntlUniversal.default.get('PCD.TIPO')), /*#__PURE__*/_react.default.createElement(PStyled, null, item.descricao), item.observacoes ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(H3Styled, null, _reactIntlUniversal.default.get('PCD.OBS')), /*#__PURE__*/_react.default.createElement(PStyled, null, item.observacoes)) : null, item.numero_cid ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(H3Styled, null, _reactIntlUniversal.default.get('PCD.CID')), /*#__PURE__*/_react.default.createElement(PStyled, null, item.numero_cid)) : null), ((_item$laudo = item.laudo) == null ? void 0 : _item$laudo.link) && /*#__PURE__*/_react.default.createElement(ReportWrapper, null, /*#__PURE__*/_react.default.createElement(Anchor, {
        href: (_item$laudo2 = item.laudo) == null ? void 0 : _item$laudo2.link,
        target: "_blank",
        rel: "noopener",
        role: "button"
      }, /*#__PURE__*/_react.default.createElement("box-icon", {
        "data-icon": "svg-icon",
        type: "solid",
        name: "file"
      }), _reactIntlUniversal.default.get('PCD.LAUDO')), ((_item$laudo3 = item.laudo) == null ? void 0 : _item$laudo3.ultima_atualizacao) && /*#__PURE__*/_react.default.createElement(_atoms.P, null, ' - ', _reactIntlUniversal.default.get('PCD.VALIDADE'), (0, _moment.default)((_item$laudo4 = item.laudo) == null ? void 0 : _item$laudo4.ultima_atualizacao).format(currentLanguage === '_enUS' ? 'MM/DD/YYYY' : 'DD/MM/YYYY')))));
    }) : null) : null);
  }
});